<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form" @click.stop="">
      <h2 class="editor-header">{{ taskTypeUpdate.id > 0 ? $t('tasktypes.edit') :  $t('tasktypes.add')}}</h2>
      <div class="col-sm-12 nopads form-data">
        <span class="span-title">
          {{ $t('tasktypes.name') }}
        </span>
        <input
            id="name"
            v-model="taskTypeUpdate.name"
            type="text"
            class="form-control mb-3"
        />
        <span class="span-title">
          {{ $t('tasktypes.color') }}
        </span>
        <swatches v-model="colors" class="mb-2" style="width: 100%; box-shadow: none; height:10em; border: 1px solid #d2d0d0" />

          <span>{{ $t('tasktypes.tracking_mode') }}</span>
          <select
              v-model="taskTypeUpdate.tracking_mode"
              class="form-select form-select-md"
          >
              <option
                  v-for="item in trackingModes"
                  :key="item.value"
                  :value="item.value"
              >
                  {{ item.text }}
              </option>
          </select>

        <task-type-vehicle-types
          :task-type="taskTypeUpdate"
          @on-vehicle-types-updated="updateVehicleTypes"
        />
        <task-type-inspections
          :task-type="taskTypeUpdate"
          @on-inspections-updated="updateInspections"
        />
        <span class="span-title">{{ $t('inspection_editor.inactive') }}</span>
          <div class="form-check mb-3">
              <input
                  id="in_active"
                  type="checkbox"
                  class="form-check-input"
                  v-model="taskTypeUpdate.inactive"
              />
          </div>
        <!-- Buttons -->
        <div class="col-sm-12 button-container">
          <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
              {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="loading" @click.stop="submitTaskType">
              {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import {restApi} from '../mixins/RestApiMixin'
import TaskTypeInspections from "./TaskTypeInspections"
import TaskTypeVehicleTypes from "./TaskTypeVehicleTypes"
import { Swatches } from '@ckpack/vue-color'
import {inject} from "vue";

export default {
    name: 'TaskTypeEditor',
    components: {TaskTypeVehicleTypes, TaskTypeInspections, Swatches},
    mixins: [workManagementHelper, restApi],
    props: {
        taskType: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            taskTypeUpdate: this.jsonToItem(this.taskType),
            trackingModes: [
                {value: 1, text: this.$t('tasktypes.tracking_road')},
                {value: 2, text: this.$t('tasktypes.tracking_bicycle')},
                {value: 3, text: this.$t('tasktypes.tracking_sport')},
                {value: 4, text: this.$t('tasktypes.tracking_none')}
            ],
            colors: ''
        }
    },

    watch: {
        colors(val) {
            if (val.hex) {
                this.taskTypeUpdate.color = val.hex
            }
        }
    },

    mounted: function () {
        this.colors = this.taskTypeUpdate.color
    },

    methods: {

        setDefaultValues: function (taskType) {
            if (taskType.name === '') {
                this.showAlert(this.$t('inspectable_editor.invalid_name'))
                return undefined
            }
            return taskType
        },

        submitTaskType: function () {
            var jsonTaskType = this.setDefaultValues(this.taskTypeUpdate)
            if (jsonTaskType !== undefined) {
                this.loading = true
                if (this.taskType.id < 1) {
                    this.restAdd(this.taskTypeUrl, jsonTaskType, this.success, this.fail)
                } else {
                    this.restUpdate(this.taskTypeUrl, jsonTaskType, this.success, this.fail)
                }
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },

        updateInspections(inspections) {
            this.taskTypeUpdate.inspections = inspections
        },

        updateVehicleTypes(types) {
            this.taskTypeUpdate.vehicle_types = []
            types.forEach(type => {
                this.taskTypeUpdate.vehicle_types.push({
                    task_type: {id: this.taskTypeUpdate.id},
                    vehicle_type: type
                })
            })
        }

    }
}
</script>
